export const BULK_UPLOAD_TEMPLATE_USER = '/files/template_user.xlsx';
export const BULK_UPLOAD_TEMPLATE_MOBILE_DEVICE = '/files/template_mobile_device.xlsx';
export const BULK_UPLOAD_TEMPLATE_PROGRAM = '/files/template_program_user.xlsx';
